export function toggleCart() {
  return dispatch => dispatch({ type: 'TOGGLE_CART' })
}

export function dismissError() {
  return dispatch => dispatch({ type: 'DISMISS_ERROR' })
}



// WEBPACK FOOTER //
// ./src/actions/ui.js